import { Vue } from 'vue-property-decorator';
import { CorePlugin, ICoreOptions } from '@samc/centricity-core';
import { logMessage } from '@/utils';
import GetVerificationTokenPlugin from './Plugins/GetVerificationTokenPlugin';
import './plugins';

// TODO: Try and figure out why this needs to be assigned here and cannot be assigned on the global scope to be used in the Vue schema
Vue.use(CorePlugin, { modalZIndex: 600, loadingZIndex: 700, onLog: logMessage, messageUrl: ((window as any).__MESSAGEURL) ?? '' } as ICoreOptions);
Vue.use(GetVerificationTokenPlugin);